<template>
  <modal
  name="notification-modal"
  height="84"
  :pivot-y=".8"
  :adaptive="true"
  :width="428"
  @opened="opened"
  @before-close="beforeClose"
  @before-open="beforeOpen">
    <div class="NotificationModal__container">
      <div class="NotificationModal__text">
        {{ text }}
      </div>
      <div class="NotificationModal__action"
           @click="action">
        <i class="icon-right-open"></i>
      </div>
    </div>
  </modal>
</template>

<script>
  export default {
    name: 'NotificationModal',
    data() {
      return {
        text: null,
        timeout: null
      };
    },
    methods: {
      action() {
        console.log('action');
        this.close();
      },
      close() {
        this.$modal.hide('notification-modal');
      },
      beforeOpen(event) {
        this.text = event.params.text;
      },
      opened() {
        this.timeout = setTimeout(() => {
          this.close();
        }, 3000);
      },
      beforeClose() {
        clearTimeout(this.timeout);
      }
    }
  };
</script>

<style scoped lang="scss">
  @import 'style.scss';
</style>



// WEBPACK FOOTER //
// notification.modal.vue?315ab50d